import {
  AppProductLine as ProductLine
} from 'graphql/models/extended';
import {
  CustomLine
} from 'graphql/models/generated';

export function isBomSubLine(line: CustomLine | ProductLine): boolean {
  return typeof line === 'object' && line.isSubLine;
}
